import { type SandboxItemVersionDispatchReadDto } from "@/config/apiClient";

type DispatchAddressLike = Pick<
  SandboxItemVersionDispatchReadDto,
  "id" | "address" | "postalCode" | "recipientName" | "quantity"
>;

type VersionWithDispatches<T extends DispatchAddressLike> = {
  SandboxItemVersionDispatch: T[];
};

export const isSameDispatchAddress = <T extends DispatchAddressLike>(
  a: T,
  b: T
) => {
  if (a.id && b.id && a.id === b.id) {
    return true;
  }

  return (
    a.address === b.address &&
    a.postalCode === b.postalCode &&
    a.recipientName === b.recipientName
  );
};

export const getDispatchAddressQuantityForVersion = <
  T extends DispatchAddressLike,
>(
  version: VersionWithDispatches<T>,
  address: T
) =>
  version.SandboxItemVersionDispatch.reduce((sum, dispatch) => {
    if (!isSameDispatchAddress(dispatch, address)) {
      return sum;
    }

    return sum + dispatch.quantity;
  }, 0);
